import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

export const COMPACT_HOTEL_CARD_WIDTH = 320
export const COMPACT_HOTEL_CARD_MIN_HEIGHT = 360
export const COMPACT_HOTEL_CARD_IMAGE_HEIGHT = 172
export const COMPACT_OTHER_CARD_IMAGE_HEIGHT = 158
export const COMPACT_OTHER_CARD_MIN_HEIGHT = 346

/** Shared carousel shell for the trip planner hotel card and existing offer-card layouts. */
const CarouselOfferCard = styled.div`
  display: grid;
  width: 80vw;
  height: 100%;
  flex-shrink: 0;

  // ChatHotelCarouselCard places a full-card click target at z-index 1 to open
  // the offer drawer. Keep controls rendered by the shared offer card above it
  // so they receive their own click before the card-level target. NestableClickable's
  // invisible button and image carousel arrows ([data-direction]) must stay absolute.
  button:not([data-nestable-clickable-overlay]):not([data-direction]) {
    position: relative;
    z-index: 2;
  }

  // Sold out villas return null so need to be hidden
  &:empty {
    display: none;
  }

  > * {
    grid-column: 1 / -1;
    grid-row: 1 / -1;
  }

  ${mediaQueryUp.tablet} {
    width: ${rem(320)};
  }

  ${mediaQueryUp.desktop} {
    &.size-medium {
      width: ${rem(512)};
    }
  }

  &.chat-cruise-carousel-card {
    width: 100%;
    min-width: 0;
    min-height: ${rem(COMPACT_OTHER_CARD_MIN_HEIGHT)};
    gap: ${rem(8)};

    > * {
      width: 100%;
      min-width: 0;
    }

    > * > :first-child {
      height: ${rem(COMPACT_OTHER_CARD_IMAGE_HEIGHT)};
      aspect-ratio: auto;
    }

    > * > :last-child {
      gap: ${rem(8)};
    }

    ${mediaQueryUp.desktop} {
      width: ${rem(320)};
      min-height: ${rem(300)};
      gap: ${rem(16)};

      > * > :first-child {
        height: auto;
        aspect-ratio: 16 / 9;
      }

      > * > :last-child {
        gap: ${rem(16)};
      }
    }
  }

  &.compact-hotel-card {
    width: 100%;
    min-width: 0;
    min-height: ${rem(COMPACT_HOTEL_CARD_MIN_HEIGHT)};

    ${mediaQueryUp.desktop} {
      width: ${rem(COMPACT_HOTEL_CARD_WIDTH)};
    }
  }

  &.chat-experience-carousel-card {
    width: 100%;
    min-width: 0;
    min-height: ${rem(COMPACT_OTHER_CARD_MIN_HEIGHT)};
    gap: ${rem(8)};

    // ExperienceOfferCard adds a wrapper around its image and content.
    > *,
    > * > * {
      width: 100%;
      min-width: 0;
    }

    > * > * > :first-child {
      height: ${rem(COMPACT_OTHER_CARD_IMAGE_HEIGHT)};
      aspect-ratio: auto;
    }

    > * > * > :last-child {
      gap: ${rem(8)};
    }

    ${mediaQueryUp.desktop} {
      width: ${rem(320)};
      min-height: ${rem(300)};
      gap: ${rem(16)};

      > * > * > :first-child {
        height: auto;
        aspect-ratio: 16 / 9;
      }

      > * > * > :last-child {
        gap: ${rem(16)};
      }
    }
  }

  body.${REBRAND_PALETTE_CLASS} & {
    border-radius: var(--border-radius-m);
    overflow: hidden;

    &.compact-hotel-card {
      border-radius: ${props => props.theme.borderRadius.L};
    }
  }
`

export default CarouselOfferCard
